import * as moment from 'moment';

export enum DateFormat {
    DEFAULT = 'DD-MM-YYYY',
    DEFAULT_DATE_UI = 'DD MMM YY',
    DEFAULT_DATE_TIME_UI = 'DD MMM YY hh:mm A',
    DEFAULT_DATE_SHORT_TIME_UI = 'DD MMM YY hh:mm',
    DEFAULT_DATE_TIME_DISPLAY = 'DD MMM YY hh:mma',
    DEFAULT_DATE_TIME_UI_DISPLAY = 'DD MMM YY, hh:mma',
    DEFAULT_DATE_TIME = 'DDMMMYYYY hh:mmA',
    DEFAULT_TIME = 'hh:mma',
    DEFAULT_DATE_CSV_BILLING = 'DDMMMYY',
    DEFAULT_DATE_MDUM = 'DD MMM YYYY',
    DEFAULT_DATE = 'DD-MMM-YYYY'
}

export function formatDate(date: string, format: DateFormat = DateFormat.DEFAULT): string {
    const momentObj = moment.utc(date);

    if (!momentObj.isValid()) {
        return '';
    }

    return momentObj.format(format);
}

export function formatDateDD(date: string, format: DateFormat = DateFormat.DEFAULT): string {
    const data = date.split('-')
    const constructedDate = data[1] + '-' + data[0] + '-' + data[2]

    const newDate = new Date(constructedDate).toUTCString()

    const momentObj = moment.utc(newDate);

    if (!momentObj.isValid()) {
        return '';
    }

    return momentObj.format(format);
}

export function formatDateDDWithoutTime(date: string,  format: DateFormat = DateFormat.DEFAULT_DATE): string {
    const data = date.split('-')
    const constructedDate = data[1] + '-' + data[0] + '-' + data[2]

    const newDate = new Date(constructedDate).toUTCString()

    const momentObj = moment.utc(newDate);

    if (!momentObj.isValid()) {
        return '';
    }

    return momentObj.format(format);
}

export function formatLocalDate(date: string, format: DateFormat = DateFormat.DEFAULT): string {
    const momentObj = moment.utc(date).local();

    if (!momentObj.isValid()) {
        return '';
    }

    return momentObj.format(format);
}

export function getFormatedTime(utcDate): string {
    // This function will return Time from Utc Date
    // Input utcDate - "2018-08-01T08:55:00.000Z"
    // Output time - "02:25pm"
    const momentObj = moment.utc(utcDate);

    if (!momentObj.isValid()) {
        return '';
    }

    return momentObj.local().format(DateFormat.DEFAULT_TIME);
}

export function formatDateWithYear(date: string, format: DateFormat = DateFormat.DEFAULT_DATE): string {
    const momentObj = moment(date, format);
    if (!momentObj.isValid()) {
        return '';
    }
    return momentObj.format('DD MMM YYYY');
}
export function formatDateWithoutYear(date: string, format: DateFormat = DateFormat.DEFAULT_DATE): string {
    const momentObj = moment(date, format);
    if (!momentObj.isValid()) {
        return '';
    }
    return momentObj.format('DD MMM');
}

export function findDifferenceBetweenDatesInMinutes(currentDate, activityDate) {
    return moment.duration(moment(currentDate, 'hh:mma')
        .diff(moment(activityDate, 'hh:mma'))).minutes()
}

export function convertTo12HourFormat(dateString) {
    const [date, time] = dateString.split(' ');
    const [initialHours, minutes, seconds] = time.split(':');
    const period = initialHours >= 12 ? 'pm' : 'am';
    const hours = initialHours % 12 || 12;
    return `${date} ${hours}:${minutes}:${seconds} ${period}`
}
